import React from 'react'

import { ExtensionInstallButton, ExtensionInstallButtonProps } from './base'
import {
  InstallType,
  useIsEligibleForInstall,
  mobileInstallTypes,
  extensionInstallTypes,
  llamaInstallTypes,
  useFirstEligibleInstall,
} from '../../../../lib/hooks/install-eligibility'
import { UnsupportedButton } from '../unsupported'

export interface BrowserSpecificExtensionInstallButtonBaseProps extends ExtensionInstallButtonProps {
  install: InstallType
}

export type BrowserSpecificExtensionInstallButtonProps = Omit<
  BrowserSpecificExtensionInstallButtonBaseProps,
  'installUrl' | 'onClick' | 'install'
>

type ExtensionInstallDisabledButtonProps = Omit<ExtensionInstallButtonProps, 'text' | 'installUrl' | 'onClick'>

// This is similar to `allInstalls` except `extensionInstallTypes` are prioritized before `llamaInstallTypes`
const alternateLinkInstallTypes = [...mobileInstallTypes, ...extensionInstallTypes, ...llamaInstallTypes]

const deviceInstallTypes = [...mobileInstallTypes, ...llamaInstallTypes]

export const ExtensionInstallDisabledButton: React.FC<ExtensionInstallDisabledButtonProps> = (props) => {
  const preferredInstall = useFirstEligibleInstall(alternateLinkInstallTypes)
  const unavailableText =
    preferredInstall && deviceInstallTypes.includes(preferredInstall)
      ? undefined
      : 'This version of Grammarly is not available on your current browser.'

  return (
    <UnsupportedButton
      {...props}
      alternateLinkInstallTypes={alternateLinkInstallTypes}
      unavailableText={unavailableText}
    />
  )
}

export const BrowserSpecificExtensionInstallButtonBase: React.FC<BrowserSpecificExtensionInstallButtonBaseProps> = (
  props
) => {
  const isCorrectBrowser = useIsEligibleForInstall(props.install)
  const { install, installUrl, ...disabledButtonProps } = props

  return isCorrectBrowser ? (
    <ExtensionInstallButton {...props} />
  ) : (
    <ExtensionInstallDisabledButton {...disabledButtonProps} />
  )
}
